<!--
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2022-07-20 10:42:39
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-11-22 15:40:58
-->
<template>
  <div
    class="ds-control ds-page data-view-page"
    :page-type="pageType"
    :class="getCss"
    :style="$pageStyle"
    ref="dataViewPage"
  >
    <!--页头-->
    <div class="ds-page-head" v-if="hasDataViewHead">
      <div ref="head" class="head-inner" :slot-name="slots[1].name">
        <slot :name="slots[1].name"></slot>
      </div>
    </div>
    <div class="ds-page-content">
      <!-- 新版布局 -->
      <div
        class="data-view-page-wrap dsf-drag-view ds-no-padding"
        :slot-name="slots[0].name"
      >
        <div class="dsf-drag-view-tools" v-if="isDesign">
          <div
            class="dsf-drag-view-tools-item dsf-drag-view-tools-item-toggles"
          >
            <DsfIcon
              :name="'tuding'"
              :class="
                isShowTools && 'dsf-drag-view-tools-item-toggles-icon-active'
              "
              @click.stop="isShowTools = !isShowTools"
            ></DsfIcon>
          </div>
          <template v-if="isShowTools">
            <div
              class="dsf-drag-view-tools-item"
              :class="{ 'active-btn': active === item }"
              v-for="item in layoutButs"
              :key="item"
              @click="handleChangeActiveScreen(item)"
            >
              {{ item }}
            </div>
          </template>
        </div>
        <div
          class="dsf-layout-container"
          :class="{ 'dsf-layout-container__design': isDesign }"
          ref="box"
        >
          <template v-if="isPageLoaded">
            <div
              v-for="(item, index) in layout"
              :key="index"
              class="dsf-layout-grid"
              v-show="handleShow(index)"
              :style="{
                'z-index': item.zIndex,
                'pointer-events': item.penetrate ? 'none' : 'auto',
              }"
            >
              <div
                class="dsf-layout-grid-item"
                v-for="it in item.layout[active]"
                :key="it.i"
                :style="setGridItemStyle(it, item)"
                :slot-name="getSlotName(it, index)"
              >
                <slot :name="getSlotName(it, index)"></slot>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div style="display: none" v-html="customCss"></div>
    <SelectLines
      :originLines="designerSelectsLines"
      v-if="designerSelectsLines.length > 1"
    />
  </div>
</template>
<script>
import { initPageTemp } from "_dataview/output/utils/relativeEvent";
import {
  utilsHandleParseCode,
  utilsHandleScope,
} from "_dataview/output/utils/event";
import * as granule from "_dataview/output/effects/granule.js";
import * as starCloud from "_dataview/output/effects/starCloud.js";
import * as starSky from "_dataview/output/effects/starSky.js";
import * as transform from "_dataview/output/effects/transform.js";
import * as vortex from "_dataview/output/effects/vortex.js";
import * as wave from "_dataview/output/effects/wave.js";

const effectsMap = new Map();
effectsMap.set("granule", granule);
effectsMap.set("starCloud", starCloud);
effectsMap.set("starSky", starSky);
effectsMap.set("transform", transform);
effectsMap.set("vortex", vortex);
effectsMap.set("wave", wave);

import defaultBGconfig from "_dataview/pc/components/common/backgroundDefault.js";
import SelectLines from "_dataview/pc/components/common/selectLines";
import { gisRelativeEventsTemp } from "_dataview/output/utils/relativeEvent.js";
import autofit from "_dataview/output/utils/autofit.js";
export default dsf.component({
  name: "DsfDataViewPage",
  ctrlCaption: "大屏页面",
  mixins: [$components.platform.DsfPage, $mixins.layout, $mixins.dataView],
  components: {
    SelectLines,
  },
  provide() {
    return {
      resolution: this.pageResolution,
      layout: this.pageLayout,
    };
  },
  props: {
    //大屏弹框配置
    dialogConfig: {
      type: Array,
      default() {
        return [
          {
            id: "default",
            background: {
              active: "color",
              color: {
                // 选色方式 默认为空 单色色盘选择 color  线性渐变 linear  径向渐变 radial
                type: "color",
                //提供给渐变使用
                image: "",
                isTheme: false,
                theme: "main",
                value: "rgba(16,75,157,0.6)",
              },
            },
            //标题高度
            titleHeight: "40",
            fontSize: "18",
            fontFamily: "Microsoft Yahei",
            color: "#FFF",
            //标题对齐
            algin: "left",
            iconColor: "#FFF",
            iconSize: "16",
            padding: [0, 0, 0, 0],
            titlePadding: [0, 0, 0, 0],
            borderWidth: "1",
            // 边框颜色
            borderColor: "#104B9D",
            // 边框圆角
            borderRadius: "5",
          },
        ];
      },
    },
    httpHeader: {
      type: Boolean,
      default: false,
    },
    //伪代码方法对象-字符串
    executeFnScope: {
      type: String,
      default: "",
    },
    //伪代码中文组件映射对象
    executeFnComp: {
      type: Object,
      default() {
        return {};
      },
    },
    //在gis一张图下运行
    isGisViewPart: {
      type: Boolean,
      default: false,
    },
    //该页面是否依赖于拓展的gis组件
    dependExtendGis: {
      type: Boolean,
      default: false,
    },
    //上传的资源是否添加微服务标识
    uploadSign: {
      type: Boolean,
      default: false,
    },
    pageType: {
      type: String,
      default: "dataview",
    },
    height: {
      type: String,
      default: "100%",
    },
    fontFamily: {
      type: String,
      default: "Microsoft Yahei",
    },
    layout: {
      type: [Array, Object],
      default: () => {
        return [
          {
            layout: {
              ">=1920": [
                { x: 0, y: 0, w: 2, h: 7, i: "A" },
                { x: 2, y: 0, w: 1, h: 5, i: "B" },
                { x: 3, y: 0, w: 1, h: 5, i: "C" },
                { x: 0, y: 7, w: 1, h: 3, i: "D" },
                { x: 1, y: 7, w: 1, h: 3, i: "E" },
                { x: 2, y: 5, w: 1, h: 5, i: "F" },
                { x: 3, y: 5, w: 1, h: 5, i: "G" },
              ],
              ">=1200": [
                { x: 0, y: 0, w: 2, h: 7, i: "A" },
                { x: 2, y: 0, w: 1, h: 5, i: "B" },
                { x: 3, y: 0, w: 1, h: 5, i: "C" },
                { x: 0, y: 7, w: 1, h: 3, i: "D" },
                { x: 1, y: 7, w: 1, h: 3, i: "E" },
                { x: 2, y: 5, w: 1, h: 5, i: "F" },
                { x: 3, y: 5, w: 1, h: 5, i: "G" },
              ],
              ">=768": [
                { x: 0, y: 0, w: 4, h: 4, i: "A" },
                { x: 0, y: 4, w: 4, h: 4, i: "B" },
                { x: 0, y: 8, w: 4, h: 4, i: "C" },
                { x: 0, y: 12, w: 4, h: 4, i: "D" },
                { x: 0, y: 16, w: 4, h: 4, i: "E" },
                { x: 0, y: 20, w: 4, h: 4, i: "F" },
                { x: 0, y: 24, w: 4, h: 4, i: "G" },
              ],
              "<768": [
                { x: 0, y: 0, w: 4, h: 4, i: "A" },
                { x: 0, y: 4, w: 4, h: 4, i: "B" },
                { x: 0, y: 8, w: 4, h: 4, i: "C" },
                { x: 0, y: 12, w: 4, h: 4, i: "D" },
                { x: 0, y: 16, w: 4, h: 4, i: "E" },
                { x: 0, y: 20, w: 4, h: 4, i: "F" },
                { x: 0, y: 24, w: 4, h: 4, i: "G" },
              ],
            },
            margin: [0, 0],
            zIndex: 1, // css控制层级
            penetrate: false, // 事件穿透
            verticalCompact: true,
            colNum: 4,
            rowHeight: 10,
            freeDrag: false, // 自由拖动
            freeResize: false, // 自由拉伸
          },
        ];
      },
    },
    //插槽
    slots: {
      type: Array,
      default() {
        return [
          { name: "center", controls: [] },
          { name: "head", controls: [] },
          // 布局插槽
          { name: "area-A-1", controls: [] },
          { name: "area-B-1", controls: [] },
          { name: "area-C-1", controls: [] },
          { name: "area-D-1", controls: [] },
          { name: "area-E-1", controls: [] },
          { name: "area-F-1", controls: [] },
          { name: "area-G-1", controls: [] },
        ];
      },
    },
    showAll: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: Array,
      default: () => [0, 0, 0, 0],
    },
    currentLevel: {
      type: Number,
      default: 1,
    },
    //slots 动画
    slotsAnimate: {
      type: Object,
      default() {
        return {};
      },
    },
    //模板
    templates: {
      type: Array,
      default() {
        return [];
      },
    },
    // 背景设置
    backgroundConfig: {
      type: Object,
      default() {
        return { ...defaultBGconfig };
      },
    },
    backgroundConfigs: {
      type: Object,
      default() {
        return {};
      },
    },
    //特效名字
    effectsName: {
      type: String,
      default: "none",
    },
    effectsConfig: {
      type: Object,
      default() {
        return {};
      },
    },
    //特效背景
    effectsConfigs: {
      type: Object,
      default() {
        return {};
      },
    },
    //初始化事件
    initDealDataFunction: {
      type: String,
      default: initPageTemp,
    },
    //大屏页面强制无水印
    waterMark: {
      type: Boolean,
      default: false,
    },
    //是否有头部针对gis组件的全屏
    hasDataViewHead: {
      type: Boolean,
      default: true,
    },
    //gis事件设置（只有该页面在gis一张图运行模式下生效）
    gisEventRealtive: {
      type: Object,
      default() {
        return gisRelativeEventsTemp;
      },
    },
    //是否定时刷寻页面数据
    isRefreshData: {
      type: Boolean,
      default: false,
    },
    //定时刷新数据间隔（分钟）
    refreshTime: {
      type: [String, Number],
      default: 1,
    },
    //是否开启缩放
    isAutoFit: {
      type: Boolean,
      default: false,
    },
    fitSize: {
      type: Array,
      default: () => [1920, 1080],
    },
  },
  data() {
    return {
      //页面当前active
      pageResolution: {
        active: ">=1920",
      },
      // 需要注入子组件的页面布局信息
      pageLayout: {
        layout: this.layout,
      },

      realHeight: 0,
      active: ">=1920",
      realWidths: [],
      loaded: false,
      areaStyle: {},
      clientWidth: 0,
      clientHeight: 0,
      resizeObserver: null,
      pageHeadHeight: 0,
      effectsBackGround: null,
      effectsMap,
      flag: true,

      containerWidth: 0,
      containerHeight: 0,

      layoutButs: [">=1920", ">=1200", ">=768", "<768"],
      isPageLoaded: false,
      isShowTools: true, // 工具栏是否折叠
      refreshTimer: null,
    };
  },
  computed: {
    //设计器下选中组件连线
    designerSelectsLines() {
      if (this.isDesign) {
        return this.$designer.getBoundSelectComps;
      }
      return [];
    },
    resolution: {
      get() {
        return { active: this.active };
      },
      set(v) {
        this.pageResolution.active = v.active;
      },
    },
    calcuLayout: {
      get() {
        return { layout: this.layout };
      },
      set(v) {
        this.pageLayout.layout = v.layout;
      },
    },

    $pageStyle() {
      let { headHeight, footHeight } = this.getHeadAndFootHeight();
      let style = {
        "padding-top": headHeight + "px",
        "padding-bottom": footHeight + "px",
        "font-family": this.fontFamily,
      };

      let gisVm = this.$parent?.pageProps?.gisVm;
      //如果是gis运行一张图 清除背景
      if (!this.isDesign && gisVm) {
        return style;
      } else {
        return {
          ...this.$colorFormatCoexist.call(this),
          ...style,
        };
      }
    },
    //当前特效名字
    getCurrentEffects() {
      return (
        (this.effectsConfigs[this.active] &&
          this.effectsConfigs[this.active].name) ||
        this.effectsConfigs[">=1920"]
      );
    },
  },
  watch: {
    currentLevel() {
      this.resize();
    },
    showAll() {
      this.resize();
    },
    resolution: {
      handler(v) {
        this.resolution = v;
      },
      deep: true,
    },
    calcuLayout: {
      handler(v) {
        this.calcuLayout = v;
      },
      deep: true,
    },
    height: {
      handler(v) {
        if (this.isDesign) {
          let height = v;
          if (!v) {
            height = "auto";
          }
          if (dsf.isNumber(height)) {
            height += "px";
          }
          this.$dispatch("design-height-change", height);
        }
      },
      immediate: true,
    },
    headHeight() {
      if (this.isDesign) {
        setTimeout(this.resizeComponent, 0);
      }
    },
    layout: {
      handler(v) {
        if (this.isDesign) {
          _.forEach(v, (item) => {
            if (!item.layout[">=1920"]) {
              item.layout[">=1920"] = item.layout[">=1200"];
            }
          });
          this.resizeComponent();
          this.setBGconfigs();
          this.setEffectsConfigs();
        }
      },
    },
    backgroundConfig: {
      handler(obj) {
        let active = this.active;
        this.$set(this.backgroundConfigs, active, obj);
      },
      deep: true,
    },
    effectsName: {
      handler(name) {
        if (this.isDesign) {
          let active = this.active;
          if (!this.effectsConfigs[active]) return;

          let config = {};
          if (!_.isEmpty(this.effectsConfigs[active].config) && !this.flag) {
            config = this.effectsConfigs[active].config;
          } else {
            config = this.effectsMap.has(name)
              ? this.effectsMap.get(name).config
              : {};
          }
          this.flag = true;
          this.$set(this.effectsConfigs, active, {
            name,
            config,
          });
          this.$emit("update:effectsConfig", config);
        }
      },
      immediate: true,
    },
    effectsConfig: {
      handler(config) {
        if (this.isDesign) {
          let active = this.active;
          let name = this.effectsName;
          let effectsConfigs = this.effectsConfigs;

          effectsConfigs[active] = {
            name,
            config,
          };
          this.$emit("update:effectsConfigs", effectsConfigs);

          this.setEffectsBG();
        }
      },
      deep: true,
    },
    getCurrentEffects: {
      handler() {
        this.setEffectsBG();
      },
    },
  },
  created() {
    // 将dsf.dataview.utils bind page
    dsf.dataview.utils.getWebPath = dsf.dataview.utils.getWebPath.bind(this)
    
    //改变根元素fontsize
    // this.changeHTMLFontSize();
    //如果未设置动画
    if (dsf.isEmptyObject(this.slotsAnimate)) {
      let keys = Object.keys(this.layout[0].layout);
      let slots = this.slots.slice(2).map((it) => it.name.substr(5));
      let slotsAnimate = {};
      keys.forEach((key) => {
        let slotObj = {};
        slots.forEach((it) => {
          slotObj[it] = "";
        });
        slotsAnimate[key] = slotObj;
      });

      this.$slotsAnimate = slotsAnimate;
      this.$emit("update:slotsAnimate", slotsAnimate);
    } else {
      this.$slotsAnimate = this.slotsAnimate;
    }

    if (this.isDesign) {
      //背景配置
      this.setBGconfigs();
      //特效配置
      this.setEffectsConfigs();
      //辅助工具
      this._watchResize = this.$watch(
        () => {
          return this.$designer.auxiliary;
        },
        () => {
          this.resizeComponent?.();
        }
      );
    }

    if (!this.isDesign) {
      _.forEach(this.layout, (item) => {
        if (!item.layout[">=1920"]) {
          item.layout[">=1920"] = item.layout[">=1200"];
        }
      });

      try {
        let page = this.$vm;

        let eventScope = {
          page: page,
        };
        let query = this.$route.query;
        //在viewpart中打开页面-gis运行一张图
        if (page.$frame) {
          let localParams = page.$frame.localParams;
          query = { ...query, ...localParams };
        }

        eventScope["路径参数"] = query;
        eventScope["全局参数"] = page.$dataview;
        let callback = utilsHandleParseCode(this.initDealDataFunction);

        callback.call(this, eventScope);
      } catch (error) {
        console.warn("伪代码执行失败", error);
      }
    }
  },
  beforeDestroy() {
    this._watch?.();
    this._watchResize?.();
    this.resizeObserver?.disconnect();
    clearTimeout(this.refreshTimer);
    //移除gis这一张图事件
    dsf.emit.$remove("GISLoad", window, this.gisLoadEvents);
    dsf.emit.$remove("GISPolygonClick", window, this.gisPolygonClickEvent);

    if (!this.isDesign && this.isAutoFit) {
      autofit?.off?.();
    }
  },
  mounted() {
    //暂时先这样
    if (!this.isDesign && this.isAutoFit) {
      let [dw, dh] = this.fitSize;
      autofit.init({
        dh,
        dw,
        el: "#app",
        resize: true,
        ignore: [".amap-container"],
      });
    }

    //gis一张图页面事件
    this.initGis();

    this.loaded = true;
    this.isPageLoaded = true;

    if (this.isDesign) {
      this._watch = this.$watch(
        "active",
        (v) => {
          this.$nextTick(() => {
            this.resizeComponent();
            let backgroundConfig = this.backgroundConfigs[v] || {};
            this.$emit("update:backgroundConfig", backgroundConfig);

            if (this.effectsConfigs[v]) {
              let config = this.effectsConfigs[v].config || {};
              this.$emit("update:effectsConfig", config);

              this.flag = false;
              let effectsName = this.effectsConfigs[v].name || "none";
              this.$emit("update:effectsName", effectsName);
            }
          });
        },
        {
          immediate: true,
        }
      );
    } else {
      this.$nextTick(() => {
        this.resize();
      });
      this.refreshData();
    }
  },
  methods: {
    handleChangeActiveScreen(screen) {
      this.active = screen;
    },
    refreshData() {
      if (this.isRefreshData) {
        this.refreshTimer = setTimeout(() => {
          let components = this.$vm.$refs;
          for (let key in components) {
            let component = components[key];
            //如果不是静态和表格数据，则需要刷新数据
            if (
              component.dataType &&
              component.dataType != "static" &&
              component.dataType != "excel"
            ) {
              component.init();
            }
          }
          this.refreshData();
        }, this.refreshTime * 60 * 1000);
      }
    },
    // 获取布局容器尺寸
    getContainerSize() {
      const { offsetHeight, offsetWidth } = this.$refs.box;
      this.containerWidth = offsetWidth;
      if (this.isDesign) {
        this.containerHeight = offsetHeight;
      } else {
        this.containerHeight =
          this.$el.parentNode.offsetHeight - this.headHeight;
        if (offsetWidth >= 1920 && this.active !== ">=1920") {
          this.active = ">=1920";
        } else if (
          offsetWidth >= 1200 &&
          offsetWidth < 1920 &&
          this.active !== ">=1200"
        ) {
          this.active = ">=1200";
        } else if (
          offsetWidth >= 768 &&
          offsetWidth < 1200 &&
          this.active !== ">=768"
        ) {
          this.active = ">=768";
        } else if (offsetWidth < 768 && this.active !== "<768") {
          this.active = "<768";
        }
      }
    },
    setGridItemStyle(
      { x, y, w, h, zIndex, penetrate },
      { colNum, colNumUnit = "%", rowHeight, rowHeightUnit = "%" }
    ) {
      const itemWidth =
        colNumUnit === "%" ? this.containerWidth / colNum : colNum;
      let itemHeight = 0;
      if (rowHeightUnit === "%") {
        const rate = parseFloat(rowHeight);
        itemHeight = (this.containerHeight / 100) * rate;
      } else {
        itemHeight = rowHeight;
      }
      // itemHeight = ((this.containerHeight / 100) * rowHeight).toFixed(2);
      let padding = _.map(this.padding, (item) => {
        return item === "" ? "0px" : `${parseInt(item)}px`;
      });

      return {
        width: `${w * itemWidth}px`,
        height: `${h * itemHeight}px`,
        top: `${y * itemHeight}px`,
        left: `${x * itemWidth}px`,
        padding: padding.join(" "),
        zIndex: zIndex === undefined ? 1 : zIndex,
        "pointer-events": this.isDesign ? "auto" : penetrate ? "none" : "auto",
      };
    },
    getSlotName({ i }, index) {
      return `area-${i}-${index + 1}`;
    },
    handleShow(index) {
      if (this.isDesign) {
        return this.showAll ? true : index + 1 === this.currentLevel;
      } else {
        return true;
      }
    },
    setEffectsBG() {
      if (this.effectsBackGround) {
        this.effectsBackGround.clear();
      }
      if (!this.effectsConfigs[this.active]) return false;
      let EffectName = this.effectsConfigs[this.active].name;
      let config = this.effectsConfigs[this.active].config;
      if (EffectName && EffectName !== "none") {
        let Effects = this.effectsMap.get(EffectName);
        let EffectsClass = Effects.fac;
        this.effectsBackGround = new EffectsClass({
          el: this.$refs.dataViewPage,
          ...config,
        });
        this.effectsBackGround.init();
      }
    },
    setBGconfigs() {
      let $backgroundConfigs = {};
      Object.keys(this.layout[0].layout).forEach((key) => {
        $backgroundConfigs[key] = this.backgroundConfigs[key]
          ? this.backgroundConfigs[key]
          : { ...defaultBGconfig };
      });
      this.$emit("update:backgroundConfigs", $backgroundConfigs);
    },
    setEffectsConfigs() {
      let effects = {};
      Object.keys(this.layout[0].layout).forEach((key) => {
        effects[key] = this.effectsConfigs[key]
          ? this.effectsConfigs[key]
          : {
              name: "none",
              config: {},
            };
      });

      this.$emit("update:effectsConfigs", effects);
    },

    async resize() {
      await this.$nextTick();
      this.setCenterHeight();
      this.resizeComponent();
      if (!this.isDesign) {
        this.setRelHeight();
      }
    },
    updateActive() {
      if (this.isDesign) {
        return;
      }
      let w = document.documentElement.offsetWidth;
      let active = "";
      let layout = this.layout;
      let array = Object.keys(layout);
      if (w >= 1920 && layout[">=1920"]) {
        active = ">=1920";
      }
      if (!active && layout[">=1200"] && w >= 1200) {
        active = ">=1200";
      }
      if (!active && layout[">=992"] && w >= 992) {
        active = ">=992";
      }
      if (!active && layout[">=768"] && w >= 768) {
        active = ">=768";
      }
      if (!active && layout["<768"]) {
        active = "<768";
      }
      if (active) {
        let index = _.findIndex(array, (it) => it == active);
        if (index >= 0) {
          for (let i = index; i >= 0; i--) {
            let a = array[i];
            if (this.layout[a]) {
              this.active = a;
              break;
            }
          }
        } else {
          this.active = array[0];
        }
      } else {
        this.active = array[0];
      }
    },
    // 新版本设置高度
    setRelHeight() {
      let heights = []; // 可能存在多个层级
      _.forEach(this.layout, (item) => {
        const { rowHeight, layout } = item;
        _.forEach(layout[this.active], (it) => {
          const height = rowHeight * (it.y + it.h);
          heights.push(height);
        });
      });
      const maxContentHeight = Math.max(...heights);
      this.$el.style.height =
        (maxContentHeight / 100) * this.containerHeight +
        this.headHeight +
        "px";
    },
    clear() {
      let backgroundConfig = this.backgroundConfig;
      backgroundConfig.image = "";
      this.$emit("update:backgroundConfig", backgroundConfig);
      return backgroundConfig;
    },
    resizeComponent() {
      this.getContainerSize();

      this.$nextTick(() => {
        _.each(this.$children || [], (it) => {
          dsf.resizeComponent(it);
        });
      });
    },
    // 相关事件作用域处理
    handleEventScope() {
      if (this.executeFnScope && !this.isDesign) {
        this.eventScope = utilsHandleScope(this, this.executeFnScope, true);
      }
    },
    // 组件伪代码统一入口
    handleCommonEmit(code, data) {
      if (!this.isDesign && code) {
        try {
          let page = this.$vm;
          //给作用域注入 vm page data
          this.eventScope.vm = this;
          this.eventScope.page = page;
          this.eventScope.data = data;
          let query = this.$route.query;
          //在viewpart中打开页面-gis运行一张图
          if (page.$frame) {
            let localParams = page.$frame.localParams;
            query = { ...query, ...localParams };
          }
          this.eventScope["路径参数"] = query;
          this.eventScope["全局参数"] = page.$dataview;

          let callback = utilsHandleParseCode(code);

          callback.call(this, this.eventScope);
        } catch (error) {
          console.warn("伪代码执行失败", error);
        }
      }
    },
    //gis加载完成事件
    gisLoadEvents(data) {
      try {
        let { fn } = this.gisEventRealtive.load;
        if (!fn) return false;
        //给组件设置当前数据
        this.currentCompentData = data;
        this.handleCommonEmit(fn, data);
      } catch (e) {
        console.error(e);
      }
    },
    gisPolygonClickEvent(data) {
      try {
        let { fn } = this.gisEventRealtive.districtClick;
        if (!fn) return false;

        //给组件设置当前数据
        this.currentCompentData = data;
        this.handleCommonEmit(fn, data);
      } catch (e) {
        console.error(e);
      }
    },
    //初始化gis一张图运行事件
    initGis() {
      //如果在gis一张图下运行
      if (this.isGisViewPart && !this.isDesign) {
        //子组件加载完成
        this.$nextTick(() => {
          //绑定函数执行上下文
          this.handleEventScope();
          let gisComponent = this.$parent?.pageProps?.gisVm;
          if (gisComponent) {
            //如果改地图已经加载完成
            if (gisComponent.isLoadMap) {
              this.gisLoadEvents();
            } else {
              dsf.emit.$on("GISLoad", this.gisLoadEvents, window);
            }
            dsf.emit.$on("GISPolygonClick", this.gisPolygonClickEvent, window);
          }
        });
      }
    },
    //获取页面的密级属性
    getConfidentiality() {
      let allComponents = this.$designer.allComponents;
      let keys = Object.keys(allComponents);
      let confidentialityLevel = "";
      let confidentialityLevelText = "";
      let releaseSecretTime = "";
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        let comp = allComponents[key];
        if (comp.confidentiality) {
          confidentialityLevel = comp.confidentialityLevel;
          confidentialityLevelText = comp.confidentialityLevelText;
          releaseSecretTime = comp.releaseSecretTime;
          break;
        }
      }

      return {
        confidentialityLevel,
        confidentialityLevelText,
        releaseSecretTime,
      };
    },
  },
  design: {
    //设计器是是否在组件上产生遮罩
    isMask: false,
  },
});
</script>
